import type { TenantType } from '../api/client';

export function getTypeLabel(instType: string | TenantType | undefined | null): string {
  switch (instType) {
    case 'CREDIT_UNION':
      return 'Credit Union';
    case 'COMMUNITY_BANK':
      return 'Community Bank';
    case 'REGIONAL_BANK':
      return 'Regional Bank';
    case 'FINTECH':
      return 'Fintech';
    case 'BROKER_DEALER':
      return 'Broker-Dealer';
    case 'INSURANCE':
      return 'Insurance';
    case 'TRANSFER_AGENT':
      return 'Transfer Agent';
    case 'TRUST_COMPANY':
      return 'Trust Company';
    case 'OTHER':
      return 'Other';
    default:
      return typeof instType === 'string' ? instType : '';
  }
}
